<template>
    <div class="baike">
        <h2 style="margin-top: 20px;">辰鳗科技集团企业百科</h2>
        <div style="padding: 20px;line-height:40px;text-align:left;margin:0 auto;" :style="{width: screenWidth >600 ?'50%':'100%'}">
<div style="margin-bottom: 40px;">国内综合能源服务商</div>

辰鳗科技集团有限公司（外文名：SMALL EEL）成立于2020年6月，注册资本3163.56万元人民币，法定代表人为朱越洋，注册地位于成都高新区，属港澳台投资非独资有限责任公司。公司定位国内综合能源服务商，秉持"每一度，我们在服务"的企业使命，以集团总部成都——云枢大脑中心、华东总部杭州——AI算法中心，为两大核心动力枢纽，在南京、天津、长沙、北京、广州、拉萨等地设有控股公司。
<div style="margin-top: 20px;"></div>
主营业务涵盖能源数字化管理、综合节能、虚拟电厂、微电网、分布式光伏+储能等方向，业务覆盖全球6个国家243个城市，累计服务工商业电力用户数量25.77万户。集团获国家高新技术企业认证及四川省专精特新中小企业认定。目前拥有48项商标、23项专利及37项软件著作权。
<div style="margin-top: 20px;"></div>

<div style="font-weight: 600;">（一）企业简介</div>
<div style="margin-bottom: 20px;"></div>
辰鳗科技集团，全球优秀的综合能源服务商，自2020年创立以来，以能源科技研发创新为驱动，致力于服务全球工商业电力用户。以集团总部成都——云枢大脑中心、华东总部杭州——AI算法中心，为两大核心动力枢纽，为中国大陆工商电力用户提供全生命周期能源管理服务。同时，集团充分发挥南京、天津、长沙、北京、广州、拉萨、杭州等控股公司的区域优势与资源效能，织就一张覆盖全国，运转高效的业务服务网络，实现能源管理业务在中国范围内的客户服务与运维保障。 
<div style="margin-top: 20px;"></div>
<div style="margin-bottom: 20px;"></div>
截至2025年底，业务版图已成功延伸至全球6个国家、243座城市，累计服务工商业电力用户数量25.77万户。下一步，集团将依托“产品+AI”服务能力，在2030年全国电力统一市场全面建成前，完成国内所有省份的电力市场规则深度学习和匹配，致力于提升云枢平台的通用性与针对性，在预测和交易相关算法的mAP准确率达到95%以上；推动新能源资产和负荷侧资源的代运营体量实现指数级增长；积极布局国际市场，针对国际上存在开放电力市场的国家，开展针对性的训练与落地应用工作。 
<div style="margin-top: 20px;"></div>
<div style="margin-bottom: 20px;"></div>
秉持“每一度，我们在服务”的企业使命，辰鳗科技集团深度聚焦综合能源服务领域。依托集团旗下自主研发的小鳗鱼云枢星能智控平台，通过人工智能、物联网、多源异构能源算法、双碳能源管控等技术，从源网荷储碳投建运一体化、新能源光储资产代运营和全国电力市场交易服务三大核心板块精准发力，积极探索公建、工业、商业等多领域绿色转型的创新路径与全新方向，为行业绿色发展注入源源不断的动力。
<div style="margin-top: 20px;"></div>
<div style="margin-bottom: 20px;"></div>
在源网荷储碳投建运一体化方面，涵盖零碳园区、工厂、区域微电网、虚拟电厂、分布式光伏、储能投建、节能技术服务、能源AI平台等多元业务实现区域绿色转型，参与园区能源资产长期运营；在新能源光储资产代运营板块，涉及电力市场运营业务、绿电交易、绿能替代、需求侧响应等关键服务，最大化实现新能源资产的价值；在全国电力市场交易服务领域，提供电力市场AI现货预测、出清、电能量交易全生命周期服务、辅助服务配套等技术。 
<div style="margin-top: 20px;"></div>
<div style="margin-bottom: 20px;"></div>
展望未来，辰鳗科技集团将以全球化为翼，以高质量发展为基，不断深化技术革新，积极拓宽服务领域，携手全球各地的合作伙伴，共同推动全球能源结构性转型与绿色低碳发展，为构建一个更加智慧、高效、可持续的零碳能源生态贡献辰鳗力量！ 
<div style="margin-top: 20px;"></div>

<div style="font-weight: 600;">（二）发展历程</div>

<div style="margin-bottom: 20px;"></div>
2020年6月，辰鳗科技集团有限公司成立<div></div>
2021年7月，辰鳗智慧能源科技（天津）有限公司<div></div>
2022年3月，浙江辰鳗能源设备制造有限公司成立<div></div>
2023年3月，江苏辰鳗科技有限公司成立<div></div>
2023年3月，四川星小鳗能源有限公司成立<div></div>
2023年11月，西藏辰鳗科技有限公司成立<div></div>
2023年12月，广东辰鳗科技有限公司成立<div></div>
2024年1月，北京辰鳗低碳科技有限公司成立<div></div>
2024年7月，辰鳗新能源（海口）有限公司成立<div></div>
2024年11月，杭州辰鳗综能科技有限公司成立<div></div>
2024年11月，四川蓉鳗智慧能源科技有限公司成立<div></div>
2025年8月，华鳗（四川）低碳科技有限公司成立<div></div>
2025年12月，湖南辰鳗能源科技有限公司成立<div></div>
<div style="margin-top: 20px;"></div>


<div style="font-weight: 600;">（三）所获荣誉</div>

<div style="margin-bottom: 20px;"></div>
荣获四川省专精特新中小企业认定<div></div>
辰鳗科技荣获国家高新技术企业认证<div></div>
辰鳗科技荣获全国科技型中小企业<div></div>
辰鳗科技荣获36氪创投平台「2023上半年最受投资人关注」企业服务Top10<div></div>
2024 APEA亚太U30上榜单位<div></div>
2025“北极星杯”综合能源服务平台优秀服务商、综合能源服务创新先锋企业<div></div>
2025中国决策式AI企业商业落地Top20榜单<div></div>
2025工信部第三届能源电子产业创新大厦创新应用类优秀奖<div></div>
2025“零碳园区工厂典型案例”能效提升解决方案优秀服务商<div></div>
<div style="margin-top: 20px;"></div>

<div style="font-weight: 600;">（四）产品与服务</div>


<div style="margin-bottom: 20px;"></div>
<div style="font-weight: 600;font-size: 14px;">虚拟电厂</div>
<div style="margin-bottom: 10px;"></div>


辰鳗借助虚拟电厂能够高效聚合各类分布式能源资源，如风电、光伏、储能系统以及可调节负荷等，形成一个灵活、智能的能源聚合体。通过智能化的协同控制与调配系统，可以精准响应调峰辅助服务市场和需求侧响应的需求，实现不同资源之间的优化配置与协同运行。在调峰辅助服务市场中，辰鳗虚拟电厂能够根据电网的实时需求，灵活调整各类资源的出力，为电网提供稳定的调峰服务，获取相应的经济收益；在需求侧响应方面，辰鳗虚拟电厂通过引导用户调整用电行为，降低高峰时段的用电负荷，实现源荷之间的深度互动，提高能源利用效率，进一步挖掘能源的经济价值。<div style="margin-bottom: 10px;"></div>

<div style="font-weight: 600;font-size: 14px;">微电网</div>
<div style="margin-bottom: 10px;"></div>

辰鳗科技提出“光伏运营+储能投建+售电代理”一体化智能微电网解决方案，以数据智能驱动“源网荷储”深度协同，着力提升工商业用户绿电消纳能力、用能经济性与供电可靠性，在微电网市场化、数字化、融合化发展浪潮中具备显著先发优势。<div style="margin-bottom: 10px;"></div>

<div style="font-weight: 600;font-size: 14px;">能源托管</div>
<div style="margin-bottom: 10px;"></div>


辰鳗科技推出了技术风险趋于零、节能客户零投入的节能合同能源管理解决方案，从前期节能评估，到合同能源管理项目谈判与合同签署，根据实际能源消耗进行节能改造，提供能源诊断、运行管理、节能评估等全面性服务，帮助客户降低能源成本、提升能源利用效率，并促进能源数字化转型，项目节能率一般约为10%-25%左右。<div style="margin-bottom: 10px;"></div>

<div style="font-weight: 600;font-size: 14px;">分布式光伏+储能</div>
<div style="margin-bottom: 10px;"></div>

辰鳗科技借助光伏运营管理系统，针对不同业务需求，提供EMC（合同能源管理）、EPC（工程总承包）、存量电站平台接入及运维三种合作模式，实现光伏电站运营智慧化管理，提供电站监控、运行对标、预警管理、资产管理、工单管理、智能巡检、检修维护、故障诊断、智慧安防、告警监测等智慧化服务，保障光伏系统稳定发电与设备安全运行，减少发电量损。<div style="margin-bottom: 10px;"></div>

<div style="font-weight: 600;font-size: 14px;">能源数智化</div>
<div style="margin-bottom: 10px;"></div>

辰鳗科技提供的能源数字化系统覆盖了建筑楼宇能源管理的全经营周期，通过智能感知终端、数据基站和能管系统，实现配电监控、用电安全、能耗监测、智能告警、电气火灾、数据报表等核心功能，为客户搭建一套数字化的能源管控平台，帮助项目减少技术损耗、管理损耗，实现能源流向可视化、成本费用精细化的绿色节能和高效运行管理。<div style="margin-bottom: 10px;"></div>

<div style="font-weight: 600;font-size: 14px;">综合节能</div>
<div style="margin-bottom: 10px;"></div>


1）空调节能：借助小鳗管家中央空调节能算法系统，对中央空调主机、水泵、冷却塔、电磁阀等设备进行安全与能效的双重监测分析，通过智能温度控制、负荷管理、智能控制算法、可变频技术、报警/预警系统等核心功能，解决暖通空调运行能耗偏高及故障难以预警的问题，使整个空调系统综合节能率达20%-30%，有效帮助用户降低能源费用，减少远程运行维护人力成本30%-50%，实时发现运行偏差减少浪费40%-70%，延长设备寿命20%，助力用户实现零碳数智化升级。<div></div>
<div style="margin-bottom: 10px;"></div>


2）照明节能：借助小鳗管家智慧照明节能改造方案，通过使用微波雷达感应灯替换现有照明灯具，实现照明系统的按需供给能耗、无感节能、无极调光、分区分组控制、场景预设等核心功能，实现公共照明、应急照明、地下车库等多场景照明需求，保证照明的安全性和能源节约，节电率可达70%。<div></div>
<div style="margin-bottom: 10px;"></div>


3）电梯节能：借助电梯动力储能回馈装置，运用储能技术、智能控制技术和电力电子变换技术，将电梯再生发电状态下产生的电能回收储存，并在电梯运行耗电状态下及时释放，用于电梯的驱动，从而以再生能源的最大限度利用实现电梯最有效节能。装置回收转换率97%以上，减少电梯机房空调用能70%-90%，延长机房设备寿命10%-20%，年综合节电率可达25%-50%。<div></div>
<div style="margin-bottom: 10px;"></div>

<div style="font-weight: 600;font-size: 14px;">计量收费管理</div>
<div style="margin-bottom: 10px;"></div>


1）水电费用：借助小鳗管家经营管理系统帮助物业完成电费统计、电网损耗、公共用电智能公摊，多种充值方式、多种扣费方式、 余额退补等核心功能。协助物业更高效的解决电费收取难题。<div></div>
<div style="margin-bottom: 10px;"></div>

2）冷热费用：借助小鳗管家中央空调分户计费系统，实现空调末端管理、实时监测、分段式计费、预存空调费用、计费轨迹、多重充值方式、面板拆机告警等核心功能，满足不同用户在不同时间段内的空调用量准确计量和费用计算。<div></div>



</div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            screenWidth: document.body.clientWidth,

        }
    },
    mounted() {
        console.log(this.screenWidth);
    },
    methods: {
        
    }
}
</script>

<style>
    .baike{
        font-size: 16px;
        height: 100vh;
        overflow: scroll;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/enterprise.vue